import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../constants/ActionNameConstants';
import { PROOFREADER_ALL_FILE_LIST_API_URL } from '../../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../../features/axiosClient';
import { proofreaderAllFilesFailure, proofreaderAllFilesSuccess } from '../actions';

const allFilesAPI = (action) => postApiRequest(PROOFREADER_ALL_FILE_LIST_API_URL, action);

function* handleAllFilesAPI(action) {
  try {
    const response = yield call(allFilesAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    console.log('response', JSON.parse(response.data.value));
    yield put(proofreaderAllFilesSuccess(response));
  } catch (error) {
    yield put(proofreaderAllFilesFailure(error));
  }
}

export function* watchProofreaderAllFilesList() {
  yield takeLatest(types.GET_PROOFREADER_ALL_FILES_LIST_REQUEST, handleAllFilesAPI);
}
